// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { errorErrorsList } from 'redux/modules/notifications'
import { fetchUserAnalysesStatuses } from 'helpers/api'
import initialAnalysisSort from './initialAnalysisSort'

// gets all the user's analyses statuses, rolled up by
// projectId && analysisTypeId && bandId

const getUsersAnalyses = () => async (dispatch, getState) => {
  const userId = getState().user.get('userId')

  // TODO - must add ability to set a time frame for this request
  // so we only get the statuses of relevant analyses

  try {
    const { entities } = await fetchUserAnalysesStatuses(userId)

    // if there are any waiting/running analyses, we should tell the caller
    // to continue polling for their updates. otherwise, we don't need to
    let pollForUpdates = false

    // prep this data to be rendered
    const preppedData = entities.map((d, i) => {
      // if the analysisStatusId isn't null, and there's no end time,
      // that means we're either waiting or running the analysis.
      if (d.analysisStatusId !== null && d.endTime === null) {
        pollForUpdates = true
      }

      // NOTE - since the status values are computed, they do not have an id.
      // so instead, create one on the fly consisting of:
      // projectId && analysisTypeId && bandId (the things that make it unique)
      d.tempId = `${d.projectId}-${d.bandId}-${d.analysisTypeId}`
      d.uniqueId = 'tempId'
      return d
    })

    const usersAnalyses = initialAnalysisSort(preppedData)

    return {
      pollForUpdates,
      usersAnalyses,
    }
  } catch (err) {
    dispatch(errorErrorsList(err, { autoDismiss: 5 }))
    throw err
  }
}

export default getUsersAnalyses
